<template>
  <form class="contact-form-1" novalidate @submit.prevent="$refs.emailDraft.openDraft()">
    <div class="form-group">
      <input
          type="text"
          name="userName"
          placeholder="Your Name"
          required
          v-model="contact.userName"
      />
    </div>

    <div class="form-group">
      <input
          type="email"
          name="email"
          placeholder="Email Address"
          required
          v-model="contact.email"
      />
    </div>

    <div class="form-group">
      <input
          type="text"
          name="phone"
          placeholder="Phone Number"
          v-model="contact.phone"
      />
    </div>


    <div class="form-group">
      <input
          type="text"
          name="subject"
          placeholder="Subject"
          required
          v-model="contact.subject"
      />
    </div>

    <div class="form-group">
                <textarea
                    name="message"
                    placeholder="Your Message"
                    required
                    v-model="contact.message">
                </textarea>
    </div>

    <EmailDraft ref="emailDraft" form-type="contact" :values="contact"/>
  </form>
</template>


<script>
import EmailDraft from './EmailDraft.vue'

export default {
  name: 'ContactForm',
  components: { EmailDraft },
  data() {
    return { contact: { userName: '', email: '', phone: '', subject: '', message: '' } }
  }
}
</script>
